<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានអំពីការបញ្ចូលប្រាក់</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវឱ្យបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>ចំនួនទឹកប្រាក់ *</label>
							<md-input type="text" v-model="topup.amount"></md-input>
						</md-field>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">ឈ្មោះគណនី</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(topup.type).length > 0">{{topup.type}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ចំនួនទឹកប្រាក់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(topup.amount).length > 0">{{config.moneylify(topup.amount)}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="createTopup()">បញ្ចូលទឹកប្រាក់</md-button>
			</div>
		</div>
	</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getSettings();
		},

		data() {
			return {
				loaded: false,
				topup: {
					type: "",
					id: "",
					amount: ""
				},
				method_withdraw: []
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.method_withdraw = data.body.data.method_withdraw

					for(let i = 0; i<this.method_withdraw.length; i++) {
						if(this.method_withdraw[i].id == this.$route.params.hash_id) {
							this.topup.id = this.method_withdraw[i].id;
							this.topup.type = this.method_withdraw[i].type;
							this.loaded=true;
						}
					}
				})
			},
			createTopup() {
				if(String(this.topup.id).length > 0 && String(this.topup.type).length > 0 && String(this.topup.amount).length > 0) {
					this.$http.post(this.config.api + "/admin/withdraw/topup", {
						id: this.topup.id,
						type: this.topup.type,
						amount: this.topup.amount
					}).then(data => {
						if (data.body.status == 'success') {
							this.tabName = 'first'
							this.$notification.notify({
								message: "បញ្ចូលទឹកប្រាក់ជោគជ័យ។",
								icon: 'done',
								type: 'success'
							});
						}
						this.$router.push("/settings");

					})
				}

			},
			clearAll() {
				this.topup = {
					id: "",
					type: "",
					amount: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Settings/Topup.vue